import React from "react";

import { withStyles } from "@material-ui/core/styles";

import TodayIcon from "@material-ui/icons/Today";

import AuthorizedAppLink from "./AuthorizedAppLink";

const styles = theme => ({});

class AddSlotToCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { classes, shop, slotId, caption } = this.props;

    return (
      <AuthorizedAppLink
        shop={shop}
        endpoint="invite"
        params={{ slotId }}
        icon={<TodayIcon />}
        text={caption}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(AddSlotToCalendar);
